import { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'

// Positions are saved continuously: by cleanup the router has already swapped location, so there is no leave hook.
const scrollPositions = new Map<string, number>()

export default function ScrollRestoration() {
  const location = useLocation()
  const navigationType = useNavigationType()

  useEffect(() => {
    // Prevent the browser's own scroll restoration from fighting with ours.
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual'
    }
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      scrollPositions.set(location.key, window.scrollY)
    }
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [location.key])

  useEffect(() => {
    if (location.hash) {
      const el = document.getElementById(location.hash.slice(1))
      if (el) {
        el.scrollIntoView()
        return
      }
    }

    if (navigationType === 'POP') {
      const saved = scrollPositions.get(location.key)
      window.scrollTo(0, saved ?? 0)
    } else {
      window.scrollTo(0, 0)
    }
  }, [location.pathname, location.search, location.hash, location.key, navigationType])

  return null
}
